import BaseService from './BaseService';

class PublicMenuService extends BaseService {
    constructor() {
        super('/api/restaurant/menu');
    }

    /**
     * Get public menu for a company by company ID
     * @param {string} companyId - The company ID
     * @returns {Promise} - Menu data
     */
    async getMenuByCompanyId(companyId) {
        return await super.customCall('GET', `/company/${companyId}`, null, { companyId: companyId }, null);
    }
}

const PublicMenuServices = new PublicMenuService();

export default PublicMenuServices;
